"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepContact = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const BookingContact_1 = require("../../models/BookingContact");
const ScrollToTopController_1 = require("../../utils/ScrollToTopController");
const ContactForm_1 = require("../contact-form/ContactForm");
const IconChevronLeft_1 = require("../icons/IconChevronLeft");
const StepContact = (props) => {
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    function handlePrevious() {
        props.onPrevious();
    }
    function handleNext() {
        if (!showErrors) {
            // User clicked button for the first time. Show validation on next render.
            setShowErrors(true);
        }
        if (isValid) {
            props.onNext();
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ScrollToTopController_1.ScrollToTop, null),
        react_1.default.createElement("h3", null, props.type),
        react_1.default.createElement(ContactForm_1.ContactForm, { contact: props.booking.contact, onContactChange: (newContact) => props.onBookingChange({
                contact: BookingContact_1.BookingContact.fromPartial(newContact, props.booking.contact),
            }), showErrors: showErrors, isValid: isValid, isValidChange: setIsValid }),
        react_1.default.createElement(Row_1.default, null,
            react_1.default.createElement(Col_1.default, null,
                react_1.default.createElement(Button_1.default, { variant: "link", onClick: handlePrevious },
                    react_1.default.createElement(IconChevronLeft_1.IconChevronLeft, null),
                    " Zur\u00FCck")),
            react_1.default.createElement(Col_1.default, { className: "text-right" },
                react_1.default.createElement(Button_1.default, { variant: "primary", size: "lg", onClick: handleNext, disabled: showErrors && !isValid }, "Weiter")))));
};
exports.StepContact = StepContact;
